import { z } from 'zod';

export const $VacationEmployerChangeSchema = z.object({
  responsibleUserId: z.string({
    message: 'Выберите ответственного сотрудника',
  }),
});

export type VacationEmployerChangeSchema = z.infer<
  typeof $VacationEmployerChangeSchema
>;
